<template>
  <a-card :bordered="false" class="m-b-20">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
          <a-select-option value="5">自定义</a-select-option>
        </a-select>
      </a-form-item>
  
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' :disabledDate="disabledDate" />
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime" :disabledDate="disabledDate" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'"  valueFormat='YYYY-MM' format='YYYY-MM' :disabledDate="disabledDate"  /> 
        <spanLimitRangeTime v-else-if="search.search_date_type=='5'" :limit="90" v-on:change="changeDate"/>
      </a-form-item>
             <a-form-item label="经销商" name='dealer_id' >
          <a-input v-model:value="search.dealer_name" readonly allClerk placeholder='请选择经销商' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 8px;" v-if='search.dealer_name'  @click='search.dealer_name="";search.dealer_sn="";' />
        </a-form-item>
           <a-form-item label="" name=''>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
     <a-spin :spinning="listLoading">
  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali">
      <div style="width:50%">
        <div ref="echartsLine" style="width:100%;height:400px"></div>
      </div>
      <div style="width:50%">
        <a-table :pagination='false' bordered rowKey='out_warehousing_sn' :columns='columns' :data-source='list'>
               <template v-slot:ranking="{ record ,index}">
            {{record.ranking}} <span :style="'display: inline-block;width:20px;height:10px;background-color:'+color[index]" ></span>
         </template>
        </a-table>
      </div>
    </div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">

    <a-table :pagination='false'  bordered rowKey='out_warehousing_sn' :columns='analyzeColumns' :data-source='analyzeList'>
         <template v-slot:action="{ record }">
             <a href="javascript:;" v-has:antiStatisticsDealerDetail="()=>{$router.push({path:'/antiFleeingGoods/statistics/dealerAnalyze',query:{'dealer_sn':record.dealer_sn,'dealer_name':record.dealer_name,'search_time':search.search_time,'search_date_type':search.search_date_type}})}" >查看分析</a>
         </template>
    </a-table>
     <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
     </a-spin>
       <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1000' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect" :parent_dealer_id="0"></selectDealer>
  </a-modal>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { fleeingGoodsDealer } from "@/api/antiFleeing";
import { message } from "ant-design-vue";
import {CloseCircleFilled } from "@ant-design/icons-vue";

export default {
  components: {CloseCircleFilled},
  setup() {
         // 切换周
    const momentTime = inject("momentTime");
    const search = ref({
      search_date_type: "1",
      start_time: "",
      end_time: "",
      dealer_sn:"",
      dealer_name:"",
      product_name:"",
      product_sku_sn:"",
      product_id:""
    });
    const state = reactive({

      showDealer:false,
      list: [],
      total: 0,
      analyzeList:[],
      color: ["#02a7f0","#ffc000", "#70b603", "#8080ff", "#f59a23", "#f59a23",'#a5a5a5'],
      listLoading:true,
      disabledDate:function(current) {
        return current && current > momentTime().subtract(0, 'days').endOf('day')
      },
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
        case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
          case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
      console.log(dateTargets(search.value.search_time),search.value.search_time)
    };
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    const changeDate=(date)=>{
      if (!date) {
        search.value.search_time = "";
        return;
      }
      search.value.search_time = date[0] + "," + date[1];
       search.value.end_time = date[1]
          search.value.start_time = date[0]
    }
    let columns = [
      {
        title: "排名",
        dataIndex: "ranking",
        key: "ranking",
         slots: { customRender: "ranking" },
      },
      {
        title: "经销商名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "占比",
        dataIndex: "percentage",
        key: "percentage",
      },
    ];
    let analyzeColumns = [
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商级别",
        dataIndex: "dealer_level",
        key: "dealer_level",
      },
      {
        title: "异常扫码数量",
        dataIndex: "code_num",
        key: "code_num",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
          slots: { customRender: "action" },
      },
    ];
      var $moment = inject("momentTime");
    const getLine = async () => {
      //  console.log(dateTargets(search.value.search_time),search.value.search_time)
      // 处理时间数据
      console.log($moment(search.value.search_time).startOf("month").format("YYYY-MM-DD"))
     switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time
          break;
        case "2":
          search.value.start_time =  search.value.search_time.split(',')[0];
          search.value.end_time = search.value.search_time.split(',')[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time).startOf("month").format("YYYY-MM-DD");
          search.value.end_time =$moment(search.value.search_time).endOf("month").format("YYYY-MM-DD");
          break;
      }
      state.listLoading=true
      let result = await fleeingGoodsDealer({
        ...search.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
      console.log(result);
      state.listLoading=false
      // 整理数据
      var chartsList = [];
      state.total = result.data.list.total;
      var total=result.data.num
      var top5Total = 0;
      result.data.chartList.forEach((element) => {
        top5Total += element.value;
        chartsList.push({
          ...element,
          value:( (element.value / total) * 100).toFixed(1),
        });
      });
      if (top5Total < total) {
        chartsList.push({
          name: "其它",
          value: (((top5Total - total) / total) * 100).toFixed(1),
        });
      }
      state.list = [];
       state.analyzeList=result.data.list.data
      result.data.chartList.forEach((v, k) => {
        state.list.push({
          ...v,
          ranking: k + 1,
          percentage: ((v.value / total) * 100).toFixed(1) + "%",
        });
      });
      return chartsList;
    };
    // 线性图表
    const echartsLine = ref("");
    var pie;
    const changNav = async () => {
      var lines = await getLine();
      console.log(lines);
      pie.setOptions({
        title: {
          text: "TOP5窜货经销商占比",
        },
        tooltip: {
          trigger: "item",
          formatter: "占比{c}%",
        },
        series: [
          {
            color: state.color,
            type: "pie",
            radius: ['40%', '70%'],
            data: Object.values(lines),
            smooth: true,
          },
        ],
      });
    };
    onMounted(() => {
      handleChange("1");
      pie = useECharts(echartsLine.value);
      changNav(1);
    });
       // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
       getLine()
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
     getLine()
    };
        //选择经销商
    const dealerSelect = (e) => {
        if (e == 0) {
          search.value.dealer_name = '总部'
          search.value.dealer_sn =0
        }else{
          search.value.dealer_name = e.dealer_name
          search.value.dealer_sn = e.dealer_sn
        }
        state.showDealer = false
     getLine()
      }
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      pageCurrentChange,
      pageSizeChange,
      search,
      handleChange,
      changNav,
      onSearch,
      changeWeek,
      echartsLine,
      columns,
      analyzeColumns,
      dealerSelect,
      changeDate
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>